import { UserStateContextType } from 'components/constants/Constants';
import { useUserState } from 'context/User';
import { isSupport } from 'helpers/Roles';

const useIsSupportUser = () => {
  const user = useUserState();

  return (
    user.type === UserStateContextType.AUTHENTICATED && isSupport(user.user)
  );
};

export default useIsSupportUser;
